import { camelCase } from 'lodash';
import { convertObjectKeys } from './utils/convertObjectKeys';
import { apiConfig } from './defineConfig';

type TFlagExcludedType<Base, Type> = {
  [Key in keyof Base]: Base[Key] extends Type
    ? never
    : Key;
};

type TAllowedNames<Base, Type> = TFlagExcludedType<Base, Type>[keyof Base];

type TOmitType<Base, Type> = Pick<Base, TAllowedNames<Base, Type>>;

export type TModelConstructorType<T> = TOmitType<T, (...args: any[]) => any>;

export abstract class Model {
  public static primaryKey = 'id';

  protected $convertCase = false;

  protected $relations: Record<string, new () => Model> = {
    //
  };

  public $update(props: Partial<TModelConstructorType<typeof this>>): this {
    const newModel = new (this.constructor as any)();
    const relatedModels: Record<string, Model | Model[]> = {};
    if (this.$convertCase || apiConfig.convertCase) {
      props = convertObjectKeys(props, camelCase);
    }
    Object
      .keys(props)
      .forEach((key: string) => {
        if (!(key in this) && !(key in this.$relations)) {
          delete props[key as keyof typeof props];
        }
      });
    Object.keys(props)
      .filter((key: string) => key in this.$relations)
      .forEach((key: string) => {
        const propsKey = key as keyof typeof props;
        const propsModelData = props[propsKey] as any;
        const RelatedModelClass = this.$relations[key];
        if (Array.isArray(propsModelData)) {
          relatedModels[key] = [];
          propsModelData.forEach((propsModel: any) => {
            const _relatedModel = new RelatedModelClass();
            const relatedModel = _relatedModel.$update(propsModel);
            (relatedModels[key] as Model[]).push(relatedModel);
          });
        } else if (typeof propsModelData === 'object') {
          const _relatedModel = new RelatedModelClass();
          relatedModels[key] = _relatedModel.$update(propsModelData);
        }
      });
    Object.keys(relatedModels).forEach((key: string) => {
      if (key in props) {
        delete props[key as keyof typeof props];
      }
    });
    Object.assign(newModel, {
      ...this,
      ...props,
    });
    Object.assign(newModel, relatedModels);
    return newModel;
  }
}
